/* @flow strict */
export function upperFirst(word: string): string {
    return word ? word.charAt(0).toUpperCase() + word.slice(1) : "";
}

export function lowerCase(value: string | undefined | null | [string, string?]): string {
    const firstValue = typeof value === "string" ? value : "";
    return (firstValue || "").toLowerCase();
}
